"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrimaryText = require("./PrimaryText.styles");

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

var _text = require("../../../../styles/2_commonComponentStyles/text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// Resources

/**
 * PrimaryText is most often used for the primary question or statement on a page.
 * This is probably your most 2_commonComponentStyles 'body' type text that you will use.
 * The exception, as called out above, is when you have a larger body of text, or text of lesser importance
 * - this will probably be ParagraphType
 */
// intentionally left as a functional component
var PrimaryText = function PrimaryText(_ref) {
  var alignment = _ref.alignment,
      bold = _ref.bold,
      children = _ref.children,
      className = _ref.className,
      colorTheme = _ref.colorTheme,
      dataTestId = _ref.dataTestId,
      fullWidth = _ref.fullWidth,
      italic = _ref.italic,
      underline = _ref.underline,
      zeroPadding = _ref.zeroPadding;
  return /*#__PURE__*/_react.default.createElement(_PrimaryText.StyledPrimaryText, {
    alignment: alignment,
    className: className,
    bold: bold,
    colorTheme: colorTheme,
    dataTestId: dataTestId,
    fullWidth: fullWidth,
    italic: italic,
    underline: underline,
    zeroPadding: zeroPadding
  }, children);
};

PrimaryText.propTypes = {
  /** alignment hook */
  alignment: _propTypes.default.oneOf([undefined, 'left', 'right', 'center']),

  /** flag for bolding text */
  bold: _propTypes.default.bool,

  /** children components or just plain old text */
  children: _propTypes2.default.children.isRequired,

  /** className hook for styling */
  className: _propTypes.default.string,

  /** Used to pick the color theme to apply to the text.
   undefined,
   'default'
   'primary',
   'tertiary',
   'cta',
   'overDark',
   */
  colorTheme: _propTypes.default.oneOf(_text.textThemes),

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag that when true allows the text to take up 100% width of its container */
  fullWidth: _propTypes.default.bool,

  /** flag for italicising text */
  italic: _propTypes.default.bool,

  /** flag for underlining text */
  underline: _propTypes.default.bool,

  /** flag to remove default padding */
  zeroPadding: _propTypes.default.bool
};
PrimaryText.defaultProps = {
  alignment: undefined,
  bold: false,
  className: '',
  colorTheme: undefined,
  fullWidth: false,
  italic: false,
  underline: false,
  zeroPadding: false
};
var _default = PrimaryText;
exports.default = _default;